import { jwtDecode } from "jwt-decode";

/** Chip de contabilización (nota → tickets en A3) en el listado de notas. */
export function accountingNoteChipFromSummary(s, t) {
  const T = (key, def) => (t ? t(key) : def);
  if (!s || !s.accountingState) {
    return {
      label: T("ExpenseUser.emptyDash", "—"),
      color: "default",
      variant: "outlined",
    };
  }
  const { accountingState, ticketCount, postedCount } = s;
  switch (accountingState) {
    case "all":
      return {
        label: T("ExpenseUser.accStateAll", "Contabilizado"),
        color: "success",
        variant: "filled",
      };
    case "partial":
      return {
        label: t
          ? t("ExpenseUser.accStatePartial", { posted: postedCount, total: ticketCount })
          : `Contabil. parcial (${postedCount}/${ticketCount})`,
        color: "warning",
        variant: "filled",
      };
    case "none":
      return {
        label: T("ExpenseUser.accStateNone", "Pendiente de contabilizar"),
        color: "error",
        variant: "filled",
      };
    case "empty":
    default:
      return {
        label: T("ExpenseUser.accStateEmpty", "Sin tickets"),
        color: "default",
        variant: "outlined",
      };
  }
}

export function hasPermisoVerTodoGastosToken() {
  try {
    const t = localStorage.getItem("token");
    if (!t) return false;
    const d = jwtDecode(t);
    const v = d?.permisoVertodoExpenses;
    if (v === true || v === 1) return true;
    if (typeof v === "string" && (v === "1" || v.trim().toLowerCase() === "true")) {
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

/**
 * Chip en un ticket según PaymentStatus (API).
 * @param {string} paymentStatus
 * @param {import("i18next").TFunction} [t] — si se omite, textos en español (legacy).
 */
export function ticketPaymentChipProps(paymentStatus, t) {
  const T = (key, def) => (t ? t(key) : def);
  const paid = String(paymentStatus || "pending").toLowerCase() === "paid";
  if (paid) {
    return {
      label: T("ExpenseUser.chipPaid", "Pagado"),
      color: "success",
      variant: "filled",
    };
  }
  return {
    label: T("ExpenseUser.chipUnpaid", "Sin pagar"),
    color: "error",
    variant: "filled",
  };
}

/**
 * Chip agregado en listado de notas (paymentSummary del back).
 * @param {import("i18next").TFunction} [t]
 */
export function paymentSummaryChipProps(s, t) {
  const T = (key, def) => (t ? t(key) : def);
  if (!s || !s.paymentState) {
    return { label: T("ExpenseUser.emptyDash", "—"), color: "default", variant: "outlined" };
  }
  const { paymentState, ticketCount, paidCount } = s;
  switch (paymentState) {
    case "all":
      return {
        label: T("ExpenseUser.payStateAll", "Pagado"),
        color: "success",
        variant: "filled",
      };
    case "card_only":
      return {
        label: T("ExpenseUser.payStateCardOnly", "Tarjeta empresa"),
        color: "info",
        variant: "filled",
      };
    case "partial":
      return {
        label: t
          ? t("ExpenseUser.payStatePartial", { paid: paidCount, total: ticketCount })
          : `Pago parcial (${paidCount}/${ticketCount})`,
        color: "warning",
        variant: "filled",
      };
    case "none":
      return {
        label: T("ExpenseUser.payStateNone", "Sin pagar (nota)"),
        color: "error",
        variant: "filled",
      };
    case "empty":
    default:
      return {
        label: T("ExpenseUser.payStateEmpty", "Sin tickets"),
        color: "default",
        variant: "outlined",
      };
  }
}

export function isCompanyCardTicket(row) {
  return String(row?.PaymentType || "cash").toLowerCase() === "company_card";
}

export function cardLast4(row) {
  const fromLabel = String(row?.CardLabel || "").match(/(\d{4})\s*$/);
  if (fromLabel) return fromLabel[1];
  const digits = String(row?.CardCuenta || "").replace(/\D/g, "");
  if (digits.length >= 4) return digits.slice(-4);
  return "";
}

export function ticketPaymentTypeChipProps(row, t) {
  const T = (key, def) => (t ? t(key) : def);
  if (isCompanyCardTicket(row)) {
    const last4 = cardLast4(row);
    return {
      label: last4
        ? t
          ? t("ExpenseUser.chipCompanyCardLast4", { last4 })
          : `Tarjeta empresa ···${last4}`
        : T("ExpenseUser.chipCompanyCard", "Tarjeta empresa"),
      color: "info",
      variant: "outlined",
    };
  }
  return {
    label: T("ExpenseUser.chipCash", "Efectivo"),
    color: "default",
    variant: "outlined",
  };
}
